// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-game-info-page .game-details-section {
  margin: 0 auto;
}
.slot-game-info-page .game-details-section .game-details-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  margin: 0 auto;
}
.slot-game-info-page .game-details-section .game-details-wrap .game-img-wrap {
  width: 100%;
  max-width: 42.5rem;
  aspect-ratio: 85/48;
  position: relative;
}
.slot-game-info-page .game-details-section .game-details-wrap .game-img-wrap .game-img-box {
  border: 6px solid var(--indigo-1000);
  border-radius: 0.75rem;
  box-shadow: 0px 4px 4px var(--black-250);
  display: flex;
  justify-content: center;
  align-items: center;
}
.slot-game-info-page .game-details-section .game-details-wrap .game-img-wrap .game-img-box img {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
  object-fit: cover;
  object-position: center;
}
.slot-game-info-page .game-details-section .game-details-wrap .game-img-wrap .btn-box {
  position: absolute;
  bottom: -2rem;
  left: 50%;
  transform: translateX(-50%);
}
.slot-game-info-page .game-details-section .game-details-wrap .game-details-list-section {
  width: 100%;
  max-width: 42.5rem;
  padding: 0;
  margin: auto 0;
}
@media screen and (max-width: 991.98px) {
  .slot-game-info-page .game-details-section .game-details-wrap {
    gap: 1.25rem;
  }
  .slot-game-info-page .game-details-section .game-details-wrap .game-img-wrap .btn-box {
    bottom: -1.25rem;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-game-info-page .game-details-section .game-details-wrap {
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    gap: 2.5rem;
  }
  .slot-game-info-page .game-details-section .game-details-wrap .game-img-wrap .btn-box {
    bottom: -1.125rem;
  }
  .slot-game-info-page .game-details-section .game-details-wrap .game-details-list-section {
    max-width: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SlotGameInfo/SlotGameInfoPageStyle.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;AAEI;EACE,WAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAAN;AAEM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAEQ;EACE,oCAAA;EACA,sBAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAV;AAEU;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;AAAZ;AAIQ;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AAFV;AAMM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAJR;AASE;EAEI;IACE,YAAA;EARN;EAWQ;IACE,gBAAA;EATV;AACF;AAeE;EAEI;IACE,2BAAA;IACA,mBAAA;IACA,sBAAA;IACA,WAAA;EAdN;EAiBQ;IACE,iBAAA;EAfV;EAmBM;IACE,gBAAA;EAjBR;AACF","sourcesContent":[".slot-game-info-page {\n  .game-details-section {\n    margin: 0 auto;\n    \n    .game-details-wrap {\n      width: 100%;\n      max-width: var(--containerWidth);\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      gap: 2rem;\n      margin: 0 auto;\n\n      .game-img-wrap {\n        width: 100%;\n        max-width: 42.5rem;\n        aspect-ratio: 85/48;\n        position: relative;\n  \n        .game-img-box {\n          border: 6px solid var(--indigo-1000);\n          border-radius: 0.75rem;\n          box-shadow: 0px 4px 4px var(--black-250);\n          display: flex;\n          justify-content: center;\n          align-items: center;\n    \n          img {\n            width: 100%;\n            height: 100%;\n            border-radius: 0.375rem;\n            object-fit: cover;\n            object-position: center;\n          }\n        }\n  \n        .btn-box {\n          position: absolute;\n          bottom: -2rem;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n  \n      .game-details-list-section {\n        width: 100%;\n        max-width: 42.5rem;\n        padding: 0;\n        margin: auto 0;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .game-details-section {\n      .game-details-wrap {\n        gap: 1.25rem;\n\n        .game-img-wrap {\n          .btn-box {\n            bottom: -1.25rem;\n          }\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    .game-details-section {\n      .game-details-wrap {\n        justify-content: flex-start;\n        align-items: center;\n        flex-direction: column;\n        gap: 2.5rem;\n\n        .game-img-wrap {\n          .btn-box {\n            bottom: -1.125rem;\n          }\n        }\n\n        .game-details-list-section {\n          max-width: unset;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
